import { APP_STATE } from './../States/app';
export function initialize() {
    return async (dispatch, getState) => {
        if (getState().app.Initialized) {
            return;
        }
        dispatch({ type: APP_STATE.Initializing });
        try {
            //Any initialization logic should go here
        } catch (err) {
            console.log(err);
        }
        dispatch({ type: APP_STATE.Initialized });
    };
};

export function updateField(field,value){
    return (dispatch) => {
        let fields = {};
        fields[field] = value;
        dispatch({type: APP_STATE.UpdateField, fields})
    }
}

const actions = {
    initialize,
    updateField
};

export default actions;